<!--
 * @Description:
 * @Author: cuncai.zhang@simceredx.com
 * @Date: 2023-06-16 15:11:09
 * @LastEditTime: 2023-11-08 13:32:42
 * @LastEditors: cuncai.zhang@simceredx.com
-->
<template>
  <div class="content">
    <el-card shadow="never" class="new-card" style="margin-top: 10px">
      <div slot="header" class="card-header">
        <div class="card-header-left">
          <el-button size="small" @click="onBack">返回</el-button>
        </div>
      </div>
      <el-descriptions column="4">
        <el-descriptions-item label="芯片识别号">{{
          detailData.chipCode
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片种类">{{
          detailData.chipType
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片使用率">{{
          getTimesNumber(detailData.chipUseRatio)
            ? getTimesNumber(detailData.chipUseRatio) + "%"
            : ""
        }}</el-descriptions-item>
        <el-descriptions-item label="订单量">{{
          detailData.orderNum
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片最大通量(G)">{{
          detailData.chipMaxFlux
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片实际上机通量(G)">{{
          detailData.chipRealFlux
        }}</el-descriptions-item>
        <el-descriptions-item label="单位通量成本(元/G)">{{
          detailData.unitFluxCost
        }}</el-descriptions-item>
        <el-descriptions-item label="单商业样本平均成本(元/例)">{{
          detailData.singleCommercialSampleCost
        }}</el-descriptions-item>
      </el-descriptions>
      <div style="height: 20px"></div>
      <el-descriptions column="4">
        <el-descriptions-item label="样本例数">{{
          detailData.sampleNum
        }}</el-descriptions-item>
        <el-descriptions-item label="商业样本例数">{{
          detailData.commercialSampleNum
        }}</el-descriptions-item>
        <el-descriptions-item label="科研样本例数">{{
          detailData.researchSampleNum
        }}</el-descriptions-item>
        <el-descriptions-item label="质控样本例数">{{
          detailData.controlSampleNum
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片实际成本(万)">{{
          detailData.chipRealCost
        }}</el-descriptions-item>
        <el-descriptions-item label="芯片理论成本(万)">{{
          detailData.chipTheoryCost
        }}</el-descriptions-item>
        <el-descriptions-item label="商业样本成本(万)">{{
          detailData.commercialSampleCost
        }}</el-descriptions-item>
        <el-descriptions-item label="质控样本成本(万)"
          >{{ detailData.controlSampleCost }}
        </el-descriptions-item>

        <el-descriptions-item label="剩余通量成本(万)">
          {{ detailData.surplusFluxCost }}
        </el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 10px; border-top: 1px solid #ebeef5">
        <div style="padding: 10px 0">
          捕获文库明细
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            @click="onDownload(1)"
            >下载明细</el-button
          >
        </div>

        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="`捕获文库数量共${chipLib.totalChipCount}个，捕获文库平均样本数${chipLib.avgSampleNum}个，捕获文库平均商业样本数${chipLib.avgCommercialSampleNum}个`"
            name="1"
          >
            <el-table
              :data="chipLib.list"
              style="width: 100%"
              border
              :height="'26vh'"
              ref="tableRef"
              :header-cell-style="{ background: '#F5F7FA', color: '#5C6474' }"
            >
              <el-table-column
                label="捕获文库编号"
                prop="libraryCode"
                align="center"
              />
              <el-table-column label="Panel" prop="panel" align="center" />
              <el-table-column
                label="样本例数"
                prop="sampleNum"
                align="center"
              />
              <el-table-column
                label="商业样本例数"
                prop="commercialSampleNum"
                align="center"
              />
              <el-table-column
                label="文库平均上机通量(G)"
                prop="averageFlux"
                align="center"
              />
            </el-table>
          </el-collapse-item>
        </el-collapse>

        <div style="padding: 10px 0">
          探针明细<el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            @click="onDownload(2)"
            >下载明细</el-button
          >
        </div>

        <el-table
          :data="chipPanel.list"
          style="width: 100%"
          border
          :height="'26vh'"
          ref="tableRef"
          :header-cell-style="{ background: '#F5F7FA', color: '#5C6474' }"
        >
          <el-table-column label="Panel" prop="panel" align="center" />
          <el-table-column label="样本例数" prop="sampleNum" align="center" />
          <el-table-column
            label="样本例数占比"
            prop="sampleRatio"
            align="center"
          >
            <template slot-scope="scope">
              {{
                getTimesNumber(scope.row.sampleRatio)
                  ? getTimesNumber(scope.row.sampleRatio) + "%"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="平均杂交数"
            prop="averageHybridNum"
            align="center"
          />
          <el-table-column
            label="商业样本例数"
            prop="commercialSampleNum"
            align="center"
          />
          <el-table-column
            label="质控样本例数"
            prop="controlSampleNum"
            align="center"
          />
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import Big from "big.js";

export default {
  data() {
    return {
      activeNames: "1",
      detailData: {},
      chipPanel: {
        list: [],
      },
      chipLib: {
        list: [],
        avgCommercialSampleNum: 0,
        avgSampleNum: 0,
        totalChipCount: 0,
      },
    };
  },

  mounted() {
    this.getDetailData();
  },
  methods: {
    onDownload(type) {
      let obj = {
        1: "getChipDownload",
        2: "getChipPanelDownload",
      };
      this.axios
        .get(obj[type], {
          chipCode: this.detailData.chipCode,
        })
        .then((result) => {
          console.log("result", result);
          if (result === 1) {
            reject();
          }

          const blob = new Blob([result]);
          console.log(blob);
          const fileName = type === 1 ? "捕获文库明细.xlsx" : "探针明细.xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$store.dispatch("app/setLoading", false);
        });
    },
    onBack() {
      this.$router.push(`/labAnalyze/NGSChip`);
    },
    getChipPanel(chipCode) {
      this.axios.get("getChipPanel", { chipCode }).then((result) => {
        this.chipPanel.list = result.data;
      });
    },
    getChipLib(chipCode) {
      this.axios.get("getChipLibrary", { chipCode }).then((result) => {
        this.chipLib.list = result.data;
      });
    },
    getChipLibDesc(chipCode) {
      this.axios.get("getChipLibraryDetail", { chipCode }).then((result) => {
        this.chipLib.avgCommercialSampleNum =
          result.data.avgCommercialSampleNum || 0;
        this.chipLib.avgSampleNum = result.data.avgSampleNum || 0;
        this.chipLib.totalChipCount = result.data.totalChipCount || 0;
      });
    },
    getTimesNumber(num) {
      if (num === null || num === undefined || num === "") {
        return "";
      }
      let x = new Big(num);
      return x.times(100);
    },
    getDetailData() {
      this.axios
        .get("getChipInfo", { id: this.$route.params.id })
        .then((result) => {
          this.detailData = result.data;
          this.getChipLib(result.data.chipCode);
          this.getChipLibDesc(result.data.chipCode);
          this.getChipPanel(result.data.chipCode);
        });
    },
  },
};
</script>

<style>
.modular-box {
  display: flex;
  flex-direction: column;
}
.el-cascader__tags .el-tag {
  color: #909399;
}
.new-card .el-card__header {
  padding: 13px 20px;
}
.new-card .el-card__body {
  padding: 20px;
  /* background: #F0F2F5; */
}
.el-dialog__headerbtn .el-dialog__close {
  color: #1cd097;
}
.el-table::before {
  z-index: inherit;
}
.new-tag1 {
  border-radius: 4px;
  background: #2672ff10;
  color: #2672ff;
  border: 1px solid #2672ff50;
  padding: 4px 10px;
}
.new-tag2 {
  border-radius: 4px;
  background: #ffa50f10;
  color: #ffa50f;
  border: 1px solid #ffa50f50;
  padding: 4px 10px;
}
.new-tag3 {
  border-radius: 4px;
  background: #ff532210;
  color: #ff5322;
  border: 1px solid #ff532250;
  padding: 4px 10px;
}
.new-tag4 {
  border-radius: 4px;
  background: #9d4de610;
  color: #9d4de6;
  border: 1px solid #9d4de650;
  padding: 4px 10px;
}
.new-tag5 {
  border-radius: 4px;
  background: #1cd09710;
  color: #1cd097;
  border: 1px solid #1cd09750;
  padding: 4px 10px;
  width: 90px;
  margin: 0 auto;
}
</style>

<style lang="scss" scoped>
.content {
  overflow-y: auto;
  height: 90vh;
  .card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .card-header-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      .top-title {
        font-size: 16px;
        color: #262626;
        font-weight: bold;
      }
      .question {
        width: 16px;
        height: 16px;
        margin-left: 4px;
      }
      .question:hover {
        cursor: pointer;
      }
    }
    .card-header-right {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }
  }
  .auth-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .auth-show-input {
    width: 300px;
  }
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
